export const PLANS_PAGE_URL = "https://intelligenic.ai/plans/";

export const redirectToPlans = () => {
    window.location.replace(PLANS_PAGE_URL);
};
